import { render } from "./RankingPreviewLeague.vue?vue&type=template&id=d46bbd92"
import script from "./RankingPreviewLeague.vue?vue&type=script&lang=js"
export * from "./RankingPreviewLeague.vue?vue&type=script&lang=js"

import "./RankingPreviewLeague.vue?vue&type=style&index=0&id=d46bbd92&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__